import { formatStepFieldLabel, isFileFieldType } from "../../data/mcaEntities";

export const fieldCodeFromLabel = (label) => {
  const code = String(label ?? "").replace(/[^A-Za-z0-9]+/g, "");
  return code || "File";
};

export const buildEntityFileName = (code, label, fileName) => {
  const approval = String(code ?? "").trim() || "MCA";
  const fieldCode = fieldCodeFromLabel(label);
  const original =
    String(fileName ?? "file")
      .split(/[/\\]/)
      .pop()
      ?.replace(/[\u0000-\u001f]/g, "")
      .trim() || "file";
  return `${approval}-${fieldCode}-${original}`;
};

export const getMcaFileUrl = (file) => {
  if (!file) return null;
  if (file.fileUrl) return file.fileUrl;
  if (file.fileLink) {
    const base = process.env.REACT_APP_FILE_URL ?? "";
    return `${base}${file.fileLink}`;
  }
  return null;
};

const uploaderName = (user) => {
  if (!user || typeof user !== "object") return "";
  return user.name || user.cname || user.aliasName || "";
};

const resolveUploader = (file, logs, stepIndex) => {
  if (file?.uploadedByName) return file.uploadedByName;
  const direct = uploaderName(file?.uploadedBy);
  if (direct) return direct;
  const log = (logs ?? []).find((entry) => {
    if (entry?.action !== "DOCUMENT_UPLOADED") return false;
    if (entry.step != null && Number(entry.step) !== stepIndex) return false;
    return entry.details?.fileName === file?.fileName;
  });
  return uploaderName(log?.by);
};

export const collectMcaStepFiles = (request) => {
  const logs = request?.logs ?? [];
  const rows = [];
  (request?.stepResults ?? []).forEach((step, stepIndex) => {
    (step?.stepFields ?? []).forEach((field) => {
      if (!isFileFieldType(field?.inputType)) return;
      const files = Array.isArray(field.value) ? field.value : [];
      files.forEach((file) => {
        if (!file || typeof file !== "object") return;
        if (!file.fileName && !file.fileUrl && !file.fileLink) return;
        rows.push({
          stepIndex,
          stepName: step?.name || `Step ${stepIndex + 1}`,
          fieldLabel: formatStepFieldLabel(field),
          fileName: file.fileName || "file",
          uploadedAt: file.uploadedAt,
          uploadedBy: resolveUploader(file, logs, stepIndex),
          href: getMcaFileUrl(file),
          entityFileName:
            file.entityFileName ||
            buildEntityFileName(request?.code, field.label, file.fileName),
        });
      });
    });
  });
  return rows;
};

export const earlierStepFiles = (request) => {
  const current = request?.currentStep ?? 0;
  return collectMcaStepFiles(request).filter((file) => file.stepIndex < current);
};
